import MyTextArea from './MyTextArea';
export default MyTextArea;
